var faqsResultsTemplate = require('./faqs-search-results.handlebars');
var scrollToElement = require('./../../shared/scripts/scrollToElement');
var { getUrlParameterByName } = require('./../../shared/scripts/UrlParameterHelper');
var faqsService = new faqsService();

$(function () {

    if (!$('#faqs-search-results-container').length) return;

    //Initialize
    setInitialCategoryFromUrl();
    getFaqs();

    //Events
    $('#faqs-apply-filters').on('click', function () {
        let isValid = arefaqsFiltersValid();
        if (isValid) {
            getFaqsFilterValues();
            if (!faqsService.options.keyword) {
                getFaqs();
            } else {
                getFaqsByKeyword();
            }
        } else {
            $('#faqs-results').empty();
        }
    });

    $('#faqs-clear-filters').on('click', function () {
        clearFilters();
        //getFaqs();
    });
});
//Generic eventhandler for enter key 
$.fn.enterKey = function (fnc) {
    return this.each(function () {
        $(this).keypress(function (e) {
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (keycode == '13') {
                fnc.call(this, e);
            }
        })
    })
}

// use custom plugin
$(document).enterKey(function () {
    console.log('You pressed enter! - enterKey');
	let isValid = arefaqsFiltersValid();
        if (isValid) {
            getFaqsFilterValues();
            if (!faqsService.options.keyword) {
                getFaqs();
            } else {
                getFaqsByKeyword();
            }
        } else {
            $('#faqs-results').empty();
        }
})
function getFaqs(categorySelected) {
    $.ajax({
        url: '/api/v1/faqcategories',
        type: 'GET'
    })
        .done(function (data) {
            var html = faqsResultsTemplate({ data: data.data });
            $('#faqs-results').html(html);
            bindTemplateEvents();

            if (faqsService.options.category) {
                scrollToElement({ scrollToThis: `#${faqsService.options.category}` });
            }
        });
}

function getFaqsByKeyword() {
    $.ajax({
        url: '/api/v1/faqquestions',
        type: 'POST',
        data: faqsService.options,
        dataType: 'json'
    })
        .done(function (data) {
            var html = faqsResultsTemplate({ data: data.data });
            $('#faqs-results').html(html);
            bindTemplateEvents();
        });
}

function bindTemplateEvents() {
    $('.scroll-to-top').on('click', function () {
        scrollToElement({ scrollToThis: '#faqs-search-filter-container' });
    });
}

function clearFilters() {
    $('#faqs-filter-keyword').val("");
    $('#faqs-filter-category').val("");
	 scrollToElement({ scrollToThis: '#faqs-search-filter-container' });
}

function arefaqsFiltersValid() {
    let keywordValue = $('#faqs-filter-keyword').val();
    let categoryValue = $('#faqs-filter-category').val();

    return true;
}

function getFaqsFilterValues() {
    let categoryValue = $('#faqs-filter-category').val();
    let keywordValue = $('#faqs-filter-keyword').val();

    faqsService.options.category = categoryValue ? categoryValue : "";
    faqsService.options.keyword = keywordValue ? keywordValue : "";
}

function setInitialCategoryFromUrl() {
    var qsCategory = getUrlParameterByName('category', window.location.search);

    if (!qsCategory)
        return;

    if (qsCategory) {
        let desiredCategoryValue = $('#faqs-filter-category option')
            .filter(function () {
                return $(this).html().replace(/\s/g, '').toUpperCase() == qsCategory.toUpperCase();
            })
            .val();

        if (!desiredCategoryValue)
            return;

        $('#faqs-filter-category').val(desiredCategoryValue)
        faqsService.options.category = desiredCategoryValue;
    }

}

function faqsService(options) {
    var faqsDefaultOptions = {
        keyword: "",
        category: ""
    };

    this.options = $.extend(true, faqsDefaultOptions, options);
}


// WEBPACK FOOTER //
// ./features/faqs/faqs.js